import * as models from './model';
import { IOrderBy } from './IOrderBy';

export interface SimilarItemsRequest {
  sourcePage: models.sourcePage;
  vendorItemId: string;
}



